import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import { Button, Card, CardMedia } from "@mui/material";
import { ClearAll, Delete, Drafts, Send } from "@mui/icons-material";
import dayjs from "dayjs";
import { getPanelFormatedDateTimeFromDateStr } from "../data/Utils";
import { deleteChatWithId, loadAllInboxData, sendReplyToInbox } from "../data/API";
import AlertDialog from "../mui/dialog";
import ProgressDialog from "../mui/progressdialog";
import ImageViewDialog from "../mui/imageViewDialog";
import { IMAGE_BASE_URL } from "../data/API_LINKS";
import { cardMediaStyle, imageCardStyle } from "../Kitchen/ViewKitchen";

function createData(name, date) {
  return { name, date };
}

export default function Inbox({

}) {
  const [selectedMessage, setSelectedMessage] = React.useState(null);
  const [replyText, setReplyText] = React.useState("");


  const [isWarning, setIsWarning] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const [data, setData] = React.useState(null);

  function loadData() {

    setIsLoading(true);
    setIsWarning(false);
    loadAllInboxData((err, data) => {
      if (err) {
        setIsWarning(true);
        setIsLoading(false);
        console.log(err);
      } else {
        setSelectedMessage(null);
        setData(data);
        setIsLoading(false);
        setIsWarning(false);
      }
    });
  }

  React.useEffect(() => {
    loadData();
  }, []);

  const [imageToView, setImageToView] = React.useState(null);




  function deleteChat(id){
    setIsLoading(true)
    deleteChatWithId(id,(err,data)=>{

      loadData();
    })
  }




  function sendMessageVendor() {
    if (replyText == "") return;
    var formatedText = "";
    formatedText =
      "Refrence No    : " +
      selectedMessage.id +
      "\n" +
      "Contact Reason :" +
      selectedMessage.reason +
      "\n" +
      "Order Id       :" +
      selectedMessage.order_id +
      "\n" +

      "Attachment URL :"+(IMAGE_BASE_URL+selectedMessage.photo) +"\n"+

      "Complaint Explaination   :" +
      selectedMessage.message +
      "\n" +
      "Admin's Message  :" +
      replyText +
      "\n"
      ;

      setIsLoading(true);
    sendReplyToInbox(
      {
        chat_id: -1,
        message: formatedText,
        order_id:selectedMessage.order_id,
        is_admin: true,
        contact_id: selectedMessage.id,
      },
      (err, d) => {

        

        loadData();

      }


    );
  }
  function sendMessage() {
    if (replyText == "") return;
    var formatedText = "";
    formatedText =
      "Refrence No    : " +
      selectedMessage.id +
      "\n" +
      "Contact Reason :" +
      selectedMessage.reason +
      "\n" +
      "Order No       :" +
      selectedMessage.order_id +
      "\n" +
      "Your Message   :" +
      selectedMessage.message +
      "\n" +
      "Admin's Reply  :" +
      replyText +
      "\n"
      ;

      setIsLoading(true);
    sendReplyToInbox(
      {
        chat_id: -1,
        message: formatedText,
        to_id: selectedMessage.user_id,
        is_admin: true,
        contact_id: selectedMessage.id,
      },
      (err, d) => {

        

        loadData();

      }


    );
  }

  return (
    <div className="  flex flex-col">
      <div
        style={{ overflow: "auto", height: window.innerHeight / 1.3 }}
        className="px-1"
      >
        <ProgressDialog msg={"Loading"} visible={isLoading} />
        <AlertDialog
          warningMessage={
            "Something went wrong! please refresh page or connect with internet"
          }
          visible={isWarning}
        />

        <ImageViewDialog
          open={imageToView != null}
          imageUrl={imageToView}
          onClose={() => setImageToView(null)}
        />
        <div
          className="flex flex-1 p-1 gap-2 mt-4"
          style={{
            boxShadow: "0px 0px 2px 1px rgba(0,0,0,0.2)",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <div className="flex-1">
            <p
              style={{
                fontWeight: "600",
                color: "green",
                fontSize: "16px",
                marginBottom: "10px",
                marginTop: "2px",
              }}
            >
              USER'S REPORTS
            </p>
            {
              (data == null || data.users.length == 0) ? <h1 className="mt-2 flex flex-1 h-32 align-middle text-center">NO MESSAGES</h1> : <TableContainer sx={{ maxHeight: "215px" }} component={Paper}>
                <Table stickyHeader size="small" aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>USER NAME</TableCell>
                      <TableCell align="right">DATETIME</TableCell>
                      <TableCell align="right">ACTION</TableCell>

                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(data.users == null ? [] : data.users).map((row) => (
                      <TableRow
                        onClick={() => setSelectedMessage(row)}
                        className="cursor-pointer hover:bg-green-200"
                        key={row.id}
                        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {row.user_name}
                        </TableCell>
                        <TableCell align="right">
                          {getPanelFormatedDateTimeFromDateStr(row.created_at)}
                        </TableCell>

                        <TableCell onClick={()=>{deleteChat(row.id)}} align="center" component="th" scope="row">
                          <Delete   />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            }

          </div>
          <div
            style={{
              width: "1px",
              background: "rgba(0, 0, 0, 0.2)",
              borderRadius: "15px",
              marginInlineStart: "5px",
              marginInlineEnd: "5px",
            }}
          />

          <div className="flex-1">
            <p
              style={{
                fontWeight: "600",
                color: "green",
                fontSize: "16px",
                marginBottom: "10px",
                marginTop: "2px",
              }}
            >
              KITCHEN'S MESSAGES
            </p>

            {data == null || data.agents.length == 0 ? <h1>No Messages</h1> : <TableContainer sx={{ maxHeight: "215px" }} component={Paper}>
              <Table stickyHeader size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>VENDOR NAME</TableCell>
                    <TableCell align="right">DATETIME</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(data.agents == null ? [] : data.agents).map((row) => (
                    <TableRow
                      onClick={() => setSelectedMessage(row)}
                      className="cursor-pointer hover:bg-green-200"
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.user_name}
                      </TableCell>
                      <TableCell align="right">
                        {getPanelFormatedDateTimeFromDateStr(row.created_at)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>}


          </div>
        </div>

        <div>
          {selectedMessage !== null ? (
            <div
              className="flex flex-1 flex-row p-1 gap-1 mt-5"
              style={{
                boxShadow: "0px 0px 2px 1px rgba(0,0,0,0.2)",
                padding: "10px",
                borderRadius: "10px",
              }}
            >
              <div style={{ flex: 1 }} className="flex flex-col  mb-1">

                <p
                  style={{ fontSize: "16px" }}
                  className=" font-normal text-green-600"
                >
                  Name:
                  <span className="text-black">
                    {" "}
                    {selectedMessage.user_name}
                  </span>

                </p>

                <p
                  style={{ fontSize: "16px" }}
                  className=" font-normal text-blue-500"
                >
                  Date & Time:
                  <span className="text-black">
                    {" "}
                    {getPanelFormatedDateTimeFromDateStr(
                      selectedMessage.created_at
                    )}
                  </span>
                </p>
                <p
                  style={{ fontSize: "16px" }}
                  className=" font-normal text-orange-600"
                >
                  User Type:
                  <span className="text-black">
                    {" "}
                    {selectedMessage.user_type}
                  </span>
                </p>
                <p
                  style={{ fontSize: "16px" }}
                  className=" font-normal text-red-600"
                >
                  Reason:
                  <span className="text-black">{selectedMessage.reason}</span>
                </p>
                <p
                  style={{ fontSize: "16px" }}
                  className=" font-normal text-teal-600"
                >
                  Order ID:
                  <span className="text-black">{selectedMessage.order_id}</span>
                </p>

                <p
                  style={{
                    fontSize: "16px",
                    color: "rgba(0,0,0,0.8)",
                    marginBottom: "4px",
                  }}
                >
                  Message
                </p>
                <TextField
                  className="w-full"
                  rows={5}
                  multiline
                  value={selectedMessage.message}
                  InputProps={{
                    readOnly: true,
                  }}
                  defaultValue={selectedMessage.message}
                />

              </div>

              <div
                style={{
                  width: "1px",
                  background: "rgba(0, 0, 0, 0.2)",
                  borderRadius: "15px",
                  marginInlineStart: "5px",
                  marginInlineEnd: "5px",
                }}
              />

              <div style={{ flex: 1 }} className=" flex flex-col">
                <Card className="mb-2" onClick={() => setImageToView(IMAGE_BASE_URL + selectedMessage.photo)} sx={imageCardStyle}>
                  <CardMedia
                    component="img"
                    src={IMAGE_BASE_URL + selectedMessage.photo}
                    style={{ width: 200, height: 100 }}

                  />
                </Card>
                <p
                  style={{
                    fontSize: "16px",
                    color: "rgba(0,0,0,0.8)",
                    marginBottom: "4px",
                  }}
                >
                  Reply
                </p>

                <TextField
                  className="w-full"
                  id="outlined-multiline-static"
                  multiline
                  onChange={(e) => setReplyText(e.target.value)}
                  value={replyText}
                  rows={6}
                />

                <div className="flex pt-3 justify-end gap-3">
                  <Button
                    color={"error"}
                    variant="contained"
                    onClick={() => setReplyText("")}
                    sx={{ paddingX: "13px" }}
                  >
                    <ClearAll sx={{ marginInlineEnd: "4px" }} /> Clear
                  </Button>
                  {/* <Button
                    color={"warning"}
                    variant="contained"
                    sx={{ paddingX: "13px" }}
                  >
                    <Drafts sx={{ marginInlineEnd: "10px" }} /> Draft
                  </Button> */}
                  <Button
                    onClick={sendMessage}
                    color={"success"}
                    variant="contained"
                    sx={{ paddingX: "13px" }}
                  >
                    Send To User<Send sx={{ marginInlineStart: "10px" }} />
                  </Button>
                  <Button
                    onClick={sendMessageVendor}
                    color={"success"}
                    variant="contained"
                    sx={{ paddingX: "13px" }}
                  >
                    Send To Vendor<Send sx={{ marginInlineStart: "10px" }} />
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <h1 style={{ marginTop: "15px", marginInlineStart: "10px" }}>
              {" "}
              Please Select Report
            </h1>
          )}
        </div>
      </div>
    </div>
  );
}
